import React from 'react';

const ChevronDown = () => (
  <svg
    width="11px"
    height="7px"
    viewBox="0 0 11 7"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon
        id="chevron_down"
        fill="#333333"
        points="1.32324219 0.306640625 5.5 4.48339844 9.61328125 0.306640625 10.9208984 1.61425781 5.5 7.02246094 0.0791015625 1.61425781"
      />
    </g>
  </svg>
);

export default ChevronDown;
